import { Component, Host, h, Element, Prop } from '@stencil/core';
import { handleCtaClick } from '@aha-app/aha-shared';

export interface AhaPromoPopoverContent extends HTMLAhaPromoPopoverContentElement {}

/**
 * `aha-promo-popover-content` should be used with `aha-promo-popover`.
 * This component manages the content of the popover, as well as the analytics click event.
 *
 * @slot title - The title of the promo popover
 */
@Component({
  tag: 'aha-promo-popover-content',
  styleUrl: 'aha-promo-popover-content.css',
  shadow: false,
})
export class AhaPromoPopoverContent {
  @Element() host!: HTMLAhaPromoPopoverContentElement;
  /**
   * The path of image to display. if none provided, no image will be shown.
   */
  @Prop() imagePath?: string;

  private showImage() {
    if (this.imagePath) {
      return <img class="promo-popover__image" src={this.imagePath} />;
    }
  }

  private handleButtonClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    const upgradeLocation = target
      ?.closest('aha-promo-popover-content')
      ?.getAttribute('upgrade-location');

    if (!upgradeLocation) return;

    handleCtaClick(event, upgradeLocation);
  }

  render() {
    return (
      <Host>
        <div id="container">
          {this.showImage()}

          <div class="title">
            <slot name="title"></slot>
          </div>
          <div class="description">
            <slot></slot>
          </div>
          <div class="button-wrapper">
            <aha-button kind="success" onClick={e => this.handleButtonClick(e)}>
              Try free
            </aha-button>
          </div>
        </div>
      </Host>
    );
  }
}
